export const calculateNetDiff = (
  price: number,
  previousPrice: number
): string => {
  if (!previousPrice) {
    return "0.00";
  }
  return (((price - previousPrice) / previousPrice) * 100).toFixed(2);
};
